import { CardFeesEnum } from '@Config/urls/cardManagementSystem.url';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { NavLink, Outlet, useParams } from 'react-router-dom';

const tabHeaders = ['Frais Périodiques', 'Frais Ponctuels'];

const tabLinks = [CardFeesEnum.RECURRING_FEE, CardFeesEnum.ONE_TIME_FEE];

const MiscellaneousFeesLayout = () => {
  const { cardFeePage } = useParams();
  const index = cardFeePage && tabLinks.indexOf(cardFeePage as CardFeesEnum) || -1;
  const tabIndex = index >= 0 ? index : 0;
  
  return (
    <>
      <CC.Tabs
        isLazy
        defaultIndex={tabIndex}
        px={{ base: '1rem', xl: '2rem' }}
        mt={'2rem'}
      >
        <CC.Box as={'div'} style={{ overflow: 'auto' }} mt={'1.2rem'}>
          <CC.TabList alignItems={'flex-start'}>
            {tabHeaders.map((tab, index) => (
              <NavLink to={tabLinks[index]} key={index}>
                <CC.Tab>{tab}</CC.Tab>
              </NavLink>
            ))}
          </CC.TabList>
        </CC.Box>

        <CC.TabPanels>
          {tabHeaders.map((_, index) => (
            <CC.TabPanel key={index}>
              <Outlet />
            </CC.TabPanel>
          ))}
        </CC.TabPanels>
      </CC.Tabs>
    </>
  );
};

export default MiscellaneousFeesLayout;
